"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgShops = function SvgShops(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8.184 8.553h19.527v11.861l-.002.039-.007.144a89.575 89.575 0 0 0-.073 2.243c-.027 1.313-.03 2.886.085 3.793.038.301.084.6.132.89.174 1.027-.594 1.977-1.573 1.977H9.536c-.961 0-1.692-.904-1.505-1.884a15.2 15.2 0 0 0 .15-.899c.07-.56.068-2.168.052-3.583a223.88 223.88 0 0 0-.044-2.52l-.004-.168V8.552Z"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M13.5 12.842a1.026 1.026 0 1 0 0-2.053 1.026 1.026 0 0 0 0 2.053Zm8.895 0a1.026 1.026 0 1 0 0-2.053 1.026 1.026 0 0 0 0 2.053Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.868 6.5h18.158v1.737H8.868V6.5Zm4.641 5.267s-.23 6.3 4.409 6.3c4.638 0 4.524-6.3 4.524-6.3"
  }));
};

var Memo = /*#__PURE__*/(0, React.memo)(SvgShops);
var _default = Memo;
exports["default"] = _default;